import { readItemField } from '../compile/item-field-reader';
import { fromBaseRecord, fromBaseUuid } from '../compile/from-base-context';
import { phpJsonInt, phpJsonString } from '../compile/php-json-values';
import { isPhpNumeric, phpJsonFloat } from '../compile/php-decimal-values';
import type { Row } from './row-plan';

/** Unsaved authoring payload -> raw override rows consumed by the shared MT compiler. */
export function spawnDraftTemplateRows(draft: Row, templateId: string, layerNames: ReadonlySet<string>): Row[] {
    const rows: Row[] = [], bits = new Map<string, number>();
    const append = (name: string, effect: unknown, qty: unknown = null): void => {
        rows.push({ monster_template_id: templateId, item_layer_type_name: name,
            item_layer_effect: phpJsonString(effect), ...(qty == null || qty === '' ? {} : { qty }) });
    };
    for (const [name, value] of Object.entries(draft)) {
        if (!layerNames.has(name) || value == null || value === '') continue;
        const list = Array.isArray(value) ? value : [value];
        if (name === 'monster_bit') {
            for (const entry of list) {
                const structured = fromBaseRecord(entry), parts = structured ? [] : phpJsonString(entry).trim().split('|');
                const id = structured ? String(readItemField(entry, 'item_id') ?? '').trim() : parts[0] ?? '';
                const qty = structured ? Math.max(1, Math.floor(phpJsonFloat(readItemField(entry, 'qty') ?? 1)))
                    : parts.length > 1 ? Math.floor(phpJsonFloat(parts[1])) : 1;
                if (fromBaseUuid(id) && qty > 0) bits.set(id, (bits.get(id) ?? 0) + qty);
            }
            continue;
        }
        if (['inventory_equipped', 'inventory_unequipped', 'starting_equipment_item_id'].includes(name)) {
            for (const entry of list) {
                const structured = fromBaseRecord(entry), id = structured ? readItemField(entry, 'item_id')
                    : entry == null ? '' : phpJsonString(entry).split('|')[0];
                if (!fromBaseUuid(id)) continue;
                const rawQty = structured ? readItemField(entry, 'qty') : null;
                const qty = name !== 'starting_equipment_item_id' && rawQty != null && rawQty !== '' && isPhpNumeric(rawQty)
                    ? String(rawQty).includes('.') ? phpJsonFloat(rawQty) : phpJsonInt(rawQty) : null;
                append(name, id, qty);
            }
            continue;
        }
        for (const effect of list) if (effect != null && effect !== '') append(name, effect,
            ['skill_roll_mod', 'skill_rolls_mod'].includes(name) ? readItemField(draft, name + '_number') ?? 1 : null);
    }
    for (const [id, qty] of bits) append('monster_bit', id, qty);
    return rows;
}
